import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { SERVICES } from "@/data/content";

export default function Services() {
  return (
    <section id="servicos" data-testid="services-section" className="bg-[#121A2D] text-white py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-[11px] sm:text-xs tracking-[0.35em] text-[#00E5A3] mb-5">ALÉM DO DESTINO</p>
          <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl max-w-2xl">
            Planejamento para <em className="font-serif italic font-medium text-[#FF5A36]">cada momento.</em>
          </h2>
        </Reveal>

        <div className="mt-14">
          {SERVICES.map((s, i) => (
            <Reveal key={s.number} delay={i * 0.08}>
              <div
                data-testid={s.testid}
                className={`group grid md:grid-cols-12 gap-6 md:gap-8 py-10 sm:py-12 border-t border-white/10 ${
                  i === SERVICES.length - 1 ? "border-b" : ""
                }`}
              >
                <div className="md:col-span-3">
                  <span className="font-display font-extrabold text-4xl text-white/15 group-hover:text-[#FF5A36] transition-colors duration-500">
                    {s.number}
                  </span>
                  <p className="mt-2 font-mono text-[10px] sm:text-[11px] tracking-[0.3em] text-white/50">
                    {s.category}
                  </p>
                </div>
                <div className="md:col-span-6">
                  <h3 className="font-display font-semibold text-xl sm:text-2xl tracking-tight group-hover:text-[#00E5A3] transition-colors duration-500">
                    {s.title}
                  </h3>
                  <p className="mt-4 text-white/65 text-base leading-relaxed max-w-xl">{s.description}</p>
                  {s.disclaimer && (
                    <p className="mt-4 text-xs text-white/40 italic leading-relaxed max-w-xl">{s.disclaimer}</p>
                  )}
                </div>
                <div className="md:col-span-3 flex md:justify-end items-start">
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`${s.testid}-btn`}
                    className="inline-flex items-center gap-2 rounded-full border border-white/25 text-white text-sm font-semibold px-6 py-3 hover:bg-[#0055FE] hover:border-[#0055FE] transition-colors duration-300"
                  >
                    {s.cta}
                    <ArrowUpRight
                      size={16}
                      className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                    />
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
